/*
* web.service.error.ts
* Copyright (c) 2016 Taillight LLC
*/

/**
* Encapsulates errors returned from web service calls
*/
export class WebServiceError extends Error {
   public status:number;
   public statusText:string;

   constructor(public response:any, statusCode:number, statusMessage?:string) {
       super();

       this.statusText = statusCode ?
           `${statusCode} - ${statusMessage}` :
           "Server error";

       // TODO: Is this the way I want to handle internal errors or should there be another code.
       this.status = statusCode || 500;

       // If there is text in the message then use that; otherwise return server error.
       this.message = statusMessage || "Server Error";
   }
}